/*
 * @Author: “zhangjiahao04”
 * @Date: 2023-08-23 15:50:14
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-19 17:42:43
 * @FilePath: \pico-ow2c-fe\src\pages\outer\about\index.tsx
 * @Description: 关于我们——moreExting组件
 * @url:www.picoxr.com/cn/about
 */
import styles from "../../index.module.scss";
import React from "react";
import LazyMedia from "@/components/LazyMedia";

import loadable from 'react-loadable'
import NoSSR from 'react-no-ssr';

const CustomSwiper = loadable({
  loader: () => import('@/components/CustomSwiper'),
  loading: () => <div></div>,
})

interface IProps {
  words: Record<string, string>; // 语言包
  awards: IAwards[]; // 获奖列表
}
interface IAwards {
  id: string;
  cover: string; // 封面
  title: string; // 标题
  briefIntroduction: string; // 简介
  coverAlt:string; // 封面alt
}
const Awards: React.FC<IProps> = ({ words, awards }) => {

  return (
    <>
      {awards && (
        <div>
          <h1 className={styles["slideshow-title"]}>
            {words?.about_us_awards_received}
          </h1>
          <div className={styles["slideshow-warp"]}>
            <NoSSR>
              <CustomSwiper
                swiperWrapClass={styles['custom-swiper-wrap']}
                swiperSlideClass={styles['slideshow-items']}>
                {awards.map((data: IAwards, index: number) => (
                  <div
                    key={data.id}
                    className={`${styles["item-warp"]}`}
                  >
                    <div className={`${styles["slideshow-item"]}`}>
                      <div className={styles["pic"]}>
                        <LazyMedia type="image" src={data.cover} alt={data?.coverAlt}/>
                      </div>
                      <div className={styles["content"]}>
                        <span className={styles["year"]}>{data.title}</span>
                        <span className={styles["text"]}>
                          {data.briefIntroduction}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </CustomSwiper>
            </NoSSR>
          </div>
        </div>
      )}
    </>
  );
};

export default Awards;
